export enum ComponentName {
    WRAPPER = 'M_RealEstate_Wrapper',
    RECOMMENDER = 'M_RealEstate_Recommender',
    RESULTLIST = 'M_RealEstate_SearchList',
}
